<template>
  <div class="login_page fillcontain">
    <transition name="form-fade" mode="in-out">
      <section class="form_contianer">
        <div class="log-face" v-if="switchhost == 'true'">
          <img src="../assets/xml_logo.png" alt="" />
        </div>
        <div class="log-face" v-if="switchhost == 'false'">
          <img src="../assets/dd_logo.png" alt="" />
        </div>
        <div class="manage_tip" v-if="switchhost == 'true'">闲驴系统后台</div>
        <div class="manage_tip" v-if="switchhost == 'false'">朵朵系统后台</div>
        <div class="bgbox">
          <div class="loginBox">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="手机号登录" name="first">
                <el-form :model="sendMsgForm">
                  <el-form-item>
                    <el-input
                      ref="phoneLength"
                      v-model="sendMsgForm.bindPhoneNum"
                      placeholder="手机号"
                      style="width: 340px"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="sendMsgForm.verificationCode"
                      placeholder="短信验证码"
                      style="width: 340px"
                      ><el-button
                        type="primary"
                        style="
                          color: #fff;
                          background: #409eff;
                          margin-bottom: 5px;
                        "
                        slot="append"
                        v-show="Verification"
                        @click="acquireCode()"
                        >获取</el-button
                      >
                      <button
                        slot="append"
                        type="text"
                        disabled
                        v-show="!Verification"
                      >
                        <span>{{ timer }}</span
                        >s后重新获取
                      </button>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      @click="phoneSubmitForm('sendMsgForm')"
                      class="submit_btn"
                      >登录</el-button
                    >
                  </el-form-item>
                  <el-form-item>
                    <el-button type="text" @click="helpBoxShow()"
                      >帮助？</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="账户密码登录" name="second">
                <el-form :model="loginForm" :rules="rules" ref="loginForm">
                  <el-form-item prop="username">
                    <el-input
                      v-model="loginForm.username"
                      style="width: 340px"
                      placeholder="用户名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      type="password"
                      style="width: 340px"
                      placeholder="密码"
                      v-model="loginForm.password"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      @click="submitForm('loginForm')"
                      class="submit_btn"
                      >登录</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </section>
    </transition>

    <el-dialog
      title="登录方式变更说明"
      :visible.sync="helpShow"
      :close-on-press-escape="false"
      :show-close="false"
      width="25%"
      center
    >
      <span
        >1.登录方式已经支持手机号登录，账号若未绑定手机号，请联系管理员更新账号信息。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="helpShow = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>



<script>
// import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      switchhost: "",
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      activeName: "first",
      sendMsgForm: {
        bindPhoneNum: '',
        verificationCode: ''
      },
      timer: 60,
      getDateNum: "",
      Verification: true, //通过v-show控制显示获取还是倒计时
      helpShow: false, // 帮助弹窗
      codesecret: "", // 验证码密文
    };
  },
  created() {
    console.log("cid",this.$route.query.cid)
  },
  mounted() {
    this.switchhost = localStorage.getItem("total_switchhost");
    this.getCookie();
  },
  methods: {
    submitForm(formName) {
      this.$opsaxios
        .post("/api/v1/member/user/login", {
          username: this.loginForm.username,
          password: this.loginForm.password,
        })
        .then((res) => {
          console.info(res);
          if (res.data.code == "0") {
            this.$message({
              type: "success",
              message: "登陆成功",
            });
            console.log("525252", res.data);
            localStorage.removeItem('total_token');
            localStorage.setItem("total_token", res.data.data.memberinfo.token);
            let _info = JSON.stringify(res.data.data.memberinfo);
            localStorage.setItem("total_userinfo", _info);
            let _datas = JSON.stringify(res.data.data.memu);
            localStorage.setItem("total_mnues", _datas);
            let paramss = {name: 'loginname', value: this.loginForm.username};
            var logindatas = Object.assign(paramss, { startTime: new Date().getTime() });
            localStorage.setItem("countdown", JSON.stringify(logindatas));
            setTimeout(() => {
              // bus.$emit("mnues", res.data.menu);
              this.$router.push({
                path: "/main",
              });
              window.location.reload();
            }, 400);
          } else {
            this.$message({
              type: "warning",
              message: res.data.message,
            });
          }
        });
    },
    // 手机登录按钮
    phoneSubmitForm() {
      this.$opsaxios
        .post("/api/v1/member/user/phone/login", {
          phone: this.sendMsgForm.bindPhoneNum,
          code: this.sendMsgForm.verificationCode,
          codesecret: this.codesecret,
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.$message({
              type: "success",
              message: "登录成功！",
            });
            localStorage.removeItem('total_token');
            localStorage.setItem("total_ms_phone", this.sendMsgForm.bindPhoneNum);
            this.setCookie(this.sendMsgForm.bindPhoneNum, 7);
            localStorage.setItem("total_token", res.data.data.memberinfo.token);
            let _info = JSON.stringify(res.data.data.memberinfo);
            localStorage.setItem("total_userinfo", _info);
            let _datas = JSON.stringify(res.data.data.memu);
            localStorage.setItem("total_mnues", _datas);
            let paramss = {name: 'loginname', value: this.loginForm.username};
            var logindatas = Object.assign(paramss, { startTime: new Date().getTime() });
            localStorage.setItem("countdown", JSON.stringify(logindatas));
            setTimeout(() => {
              // bus.$emit("mnues", res.data.menu);
              this.$router.push({
                path: "/main",
              });
              window.location.reload();
            }, 400);
          } else {
            this.$message({
              type: "warning",
              message: res.data.message,
            });
          }
        });
    },
    // 设置cookie
    setCookie(c_phone, exdays) {
      var exdate = new Date(); // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
      // 字符串拼接cookie
      window.document.cookie =
        "userPhone" + "=" + c_phone + ";path=/;expires=" + exdate.toGMTString();
    },
    // 读取cookie
    getCookie() {
      var _this = this;
      let cookie=document.cookie
      if (cookie.length > 0) {
        var arr = cookie.split(";"); // 这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); // 再次切割
          if (arr2[0].replace(/\s*/g, "") === "userPhone") {
            _this.sendMsgForm.bindPhoneNum = arr2[1]; // 保存到保存数据的地方
          } 
        }
      }
    },
    // 帮助盒子
    helpBoxShow() {
      this.helpShow = true;
    },
    // 获取验证码
    acquireCode() {
      if (this.sendMsgForm.bindPhoneNum == null) {
        this.$message({
          type: "error",
          message: "请输入手机号",
        });
        return;
      } else if (this.$refs.phoneLength.value.length < 11) {
        this.$message({
          type: "error",
          message: "请补全手机号",
        });
        return;
      } else if (this.$refs.phoneLength.value.length > 11) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号",
        });
        return;
      }
      // 获取当前时间
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      month = "" + month;
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      strDate = "" + strDate;
      this.getDateNum = year + month + strDate;
      this.$opsaxios
        .post("/api/v1/member/phone/sendcode", {
          phone: this.sendMsgForm.bindPhoneNum,
          md5code: this.$md5(this.sendMsgForm.bindPhoneNum + this.getDateNum),
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.codesecret = res.data.data;
            this.$message({
              type: "success",
              message: "短信发送成功，请注意查收！",
            });
          } else {
            this.$message({
              type: "warning",
              message: res.data.message,
            });
          }
        });
      this.btnDisable = true;
      this.Verification = false; //点击button改变v-show的状态
      let auth_timer = setInterval(() => {
        //定时器设置每秒递减
        this.timer--; //递减时间
        if (this.timer <= 0) {
          this.Verification = true; //60s时间结束还原v-show状态并清除定时器
          clearInterval(auth_timer);
        }
      }, 1000);
      this.timer = 60;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>


<style scoped>
.login_page {
  width: 100%;
  height: 100vh;
  /* text-align: center; */
  background: url("../assets/login_bg01.png") center center no-repeat;
}
.form_contianer {
  width: 320px;
  height: 360px;
  text-align: center;
  position: absolute;
  left: calc(50% - 160px);
  top: calc(50% - 300px);
}
.log-face img {
  width: 100px;
  height: auto;
  margin: 0 auto;
}

.loginBox {
  height: 250px;
  padding: 50px;
}
.bgbox {
  width: 520px;
  height: 396px;
  background: #fff;
  border-radius: 16px;
  position: absolute;
  left: -88px;
  top: 210px;
}
.manage_tip {
  color: #fff;
  font-size: 28px;
  margin: 25px 0;
}
.manage_tip p {
  font-size: 34px;
  padding: 20px 0;
}
.submit_btn {
  margin-top: 22px;
  border: none;
  color: #fff;
  width: 340px;
  font-size: 16px;
  background: #409eff;
  
}
.form-fade-enter-active,
.form-fade-leave-active {
  transition: all 1s;
}
.form-fade-enter,
.form-fade-leave-active {
  transform: translate3d(0, -50px, 0);
  opacity: 0;
}

>>> .el-tabs__item.is-active {
  color: #409eff;
  cursor: pointer;
}
>>> .el-tabs__item {
  color: #acafb6;
}
>>> .el-input-group__append,
.el-input-group__prepend {
  background-color: #fff;
  border: 0;
  border-bottom: 1px solid #c0c4cc;
  border-radius: 0;
}
>>> .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 107px;
}
>>> .el-input__inner {
  border: 0;
  border-bottom: 1px solid #c0c4cc;
  border-radius: 0;
}

>>> .el-tabs__nav-wrap::after {
  background: #fff;
}
>>> .el-form-item__error {
  left: 39px;
}

>>> .el-dialog {
  margin-top: 19.7% !important;
  margin-left: 38% !important;
}
>>> .el-dialog__title {
  text-align: left !important;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue